import Component from './TreeNodeList.component';

export default Component;
